import React, { FC, useEffect, useState } from "react";
import DashboardSidebar from "../atoms/DashboardSidebar";
import DashboardList from "../molecules/DashboardList";
import { service } from "../../../services/AxiosServices";
import MainLayout from "../../Layouts/MainLayout";
import { Link } from "react-router-dom";
import Spinner from "../atoms/Spinner";
import { useCrewAuth } from "../../../context/CrewAndSpaceContext";
import AccessControl from "../molecules/AccessControl";
import KnowledgehubIcon from "../../static/svg/KnowledgehubIcon";


interface CrewProps {
  id: number;
  crew_name: string;
  crew_description: string;
  phase?:number
}

interface SpaceProps {
  id: number;
  space_name: string;
  space_description: string;
  phase?:number
}

interface CrewType {
  id: number;
  title: string;
  description: string;
}

interface SpaceType {
  id: number;
  title: string;
  description: string;
}

const DashboardDetailsPage: FC = () => {
  const [loadingCrews, setLoadingCrews] = useState<boolean>(false);
  const [loadingSpaces, setLoadingSpaces] = useState<boolean>(false);
  const { crews, spaces, setCrews, setSpaces, deleteCrew, deleteSpace } = useCrewAuth()!;
  // Fetch crews and spaces on component mount
  useEffect(() => {
    async function fetchCrews() {
      setLoadingCrews(true);
      try {
        const response = await service<{ crews: CrewProps[] }>(
          "api/get-all-crew",
          "post",
          { project_id: localStorage.getItem("project_id") }
        );

        const mappedCrews = response?.data?.crews?.map((crew: CrewProps) => ({
          id: crew?.id,
          title: crew?.crew_name || `Crew ${crew.id}`,
          description: crew?.crew_description?.trim() ? crew.crew_description : "No description available",
          phase:crew?.phase
        })) || [];

        setCrews(mappedCrews);
      } catch (err) {
        console.error("Error fetching crews:", err);
      } finally {
        setLoadingCrews(false);
      }
    }

    async function fetchSpaces() {
      setLoadingSpaces(true);
      try {
        const response = await service<{ response: SpaceProps[] }>(
          "api/get-spaces",
          "post",
          { project_id: localStorage.getItem("project_id") }
        );

        const mappedSpaces = response?.data?.response?.map((space: SpaceProps) => ({
          id: space?.id,
          title: space?.space_name || `Space ${space.id}`,
          description: space?.space_description?.trim() ? space.space_description : "No description available",
          phase:space?.phase
        })) || [];

        setSpaces(mappedSpaces);
      } catch (err) {
        console.error("Error fetching spaces:", err);
      } finally {
        setLoadingSpaces(false);
      }
    }

    fetchCrews();
    fetchSpaces();
  }, [setCrews, setSpaces]);

  const handleDeleteCrew = (id: number) => {
    deleteCrew(id);
  };

  const handleDeleteSpace = (id: number) => {
    deleteSpace(id);
  };

  const isLoading = loadingCrews || loadingSpaces;

  return (
    <MainLayout>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="p-2 my-2">
            <AccessControl
              requiredPermissions={[
                { permission: "manage_spaces", types: ["read"], }
              ]}
              renderNoAccess={
                <>
                </>
              }
            >
              <div className="d-flex align-items-center mb-4">
                <span className="me-3"><KnowledgehubIcon /></span>
                <div className="pageTitle">My knowledge hubs</div>
              </div>


              <DashboardList
                tiles={spaces}
                category="knowledge-hubs"
                loading={false}
                onDelete={handleDeleteSpace}
              />
              <div className="text-end">
                {spaces.length > 3 && (
                  <Link to={"/knowledge-hubs"} className="">
                    View more
                  </Link>
                )}
              </div>
            </AccessControl>

            <AccessControl
              requiredPermissions={[
                // { permission: "create_crew", types: ["read"],allowedRoles: ['Admin', 'C-Admin'] }
                { permission: "create_crew", types: ["read"] }
              ]}
              renderNoAccess={
                <></>
              }
            >

              <div className="d-flex align-items-center mb-4">
                <span className="me-3"><KnowledgehubIcon /></span>
                <div className="pageTitle"> My agentic crews</div>
              </div>
              <DashboardList
                tiles={crews}
                category="crews"
                loading={false}
                onDelete={handleDeleteCrew}
              />
              <div className="text-end">
                {crews.length > 3 && (
                  <Link to="/crews" className="">
                    View more
                  </Link>
                )}
              </div>
            </AccessControl>
          </div>

        </>
      )
      }
    </MainLayout >
  );
};

export default DashboardDetailsPage;